export function formatDate(d) {
    const z = (num) => (num < 10 ? '0' + num : num);
    return `${z(d.getDate())}.${z(d.getMonth() + 1)}.${z(d.getFullYear())}, ${z(d.getHours())}:${z(d.getMinutes())}`;
}
